import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import { ErrorProps } from 'services/error/types';

// Global Selectors
import { selectEntityErrorsExist } from 'services/entities/selectors';

interface OwnProps extends ErrorProps {
    children: React.ReactElement;
}

interface ConnectedProps {
    errorsExist?: boolean;
}

type Props = OwnProps & ConnectedProps;

export class EntityErrorsExistGateComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { errorsExist, children } = this.props;
        if (!errorsExist) {
            return null;
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    errorsExist: selectEntityErrorsExist
});

export default connect(mapStateToProps)(EntityErrorsExistGateComponent);
